export interface TrustedContentKey {
  readonly environment: "development" | "production";
  readonly keyId: string;
  readonly publicKey: JsonWebKey;
}

export const trustedContentKeys: readonly TrustedContentKey[] = [
  {
    environment: "development",
    keyId: "development-fixture-p256-1",
    publicKey: {
      key_ops: ["verify"],
      ext: true,
      kty: "EC",
      x: "xmg-wU8jmHhfeqDkQWsZbbcK1_PRNSZUVSnFUDawdO0",
      y: "mZYMtFvFqMkrSEjmRx9aoW4kYb2zEpTddsiu405OPi4",
      crv: "P-256",
    },
  },
] as const;

const ephemeralDevelopmentKeys = new Map<string, TrustedContentKey>();

export function registerEphemeralDevelopmentKey(key: TrustedContentKey): void {
  if (key.environment !== "development" || !key.keyId.startsWith("ephemeral-development-")) {
    throw new Error("Only explicitly ephemeral development verification keys may be registered.");
  }
  ephemeralDevelopmentKeys.set(key.keyId, key);
}

export function clearEphemeralDevelopmentKeysForTests(): void {
  ephemeralDevelopmentKeys.clear();
}

export function findTrustedContentKey(keyId: string): TrustedContentKey | undefined {
  return (
    trustedContentKeys.find((key) => key.keyId === keyId) ?? ephemeralDevelopmentKeys.get(keyId)
  );
}
